import ForgotPassword from "components/Authentication/ForgotPassword";
import React from "react";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

ForgotPasswordPage.title = "Forgot Password";

export default ForgotPasswordPage;
